import { render, staticRenderFns } from "./InstrumentJigAdd.vue?vue&type=template&id=08bdfd80"
import script from "./InstrumentJigAdd.vue?vue&type=script&lang=js"
export * from "./InstrumentJigAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports